import { render, staticRenderFns } from "./EducationCard.vue?vue&type=template&id=39071ed8&scoped=true"
import script from "./EducationCard.vue?vue&type=script&lang=js"
export * from "./EducationCard.vue?vue&type=script&lang=js"
import style0 from "./EducationCard.vue?vue&type=style&index=0&id=39071ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39071ed8",
  null
  
)

export default component.exports